<div class="py-4">
  <mat-card class="px-3">
    <mat-card-header>
      <shared-title>Reserva</shared-title>
    </mat-card-header>

    <mat-card-content>
      <form [formGroup]="formDetail">
        <div>
          <h2>Datos de la reserva:</h2>
          <p><strong>Tipo:</strong></p>
          <p><strong>Iniciado:</strong></p>
          <p><strong>Duración:</strong></p>
          <p><strong>Recurrencia:</strong></p>
          <p><strong>Edificio:</strong></p>
          <p><strong>Nivel:</strong></p>
        </div>

        <br />
        <button mat-raised-button color="warn" class="col-6">Ver Mapa</button>
        <br />
        <br />

        <div class="grid">
          <mat-form-field class="col-3" appearance="outline">
            <mat-label>Disponibles</mat-label>
            <mat-select [disabled]="disableSelect.value">
              <mat-option value="option1">P001GT</mat-option>
              <mat-option value="option2">P004GT</mat-option>
              <mat-option value="option3">P007GT</mat-option>
              <mat-option value="option4">P0010GT</mat-option>
            </mat-select>
          </mat-form-field>

          <mat-form-field class="col-3" appearance="outline">
            <mat-label>Reservados</mat-label>
            <mat-select [disabled]="disableSelect.value">
              <mat-option value="option1">P003GT</mat-option>
              <mat-option value="option2">P006GT</mat-option>
              <mat-option value="option3">P008GT</mat-option>
              <mat-option value="option3">P009GT</mat-option>
            </mat-select>
          </mat-form-field>
        </div>

        <br />
        <br />
        <button mat-raised-button color="warn" (click)="goBack()">
          Regresar
        </button>
        <!-- <a routerLink="detail-page"><button class="btn btn-success pull-right" > Add Customer</button></a> -->
      </form>
    </mat-card-content>
  </mat-card>
</div>
